import React, { Component } from "react";
import customers from "./top25Customers.json";

export default class TopCustomersReport extends Component {
  render() {
    return (
      <div className="container-fluid">
        <h2 className="mt-30 page-title">Top 25 Customers Report</h2>

        <div className="card card-static-2 mt-30 mb-30">
          <div className="card-title-2">
            <h4>Customer Spending Summary</h4>
          </div>

          <div className="card-body-table">
            <div className="table-responsive">
              <table className="table ucp-table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Customer Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Total Orders</th>
                    <th>Total Spend (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {customers.map((row, index) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.customerName}</td>
                      <td>{row.email}</td>
                      <td>{row.phone}</td>
                      <td>{row.totalOrders}</td>
                      <td>₹{row.totalSpend.toLocaleString("en-IN")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/report/view/index.js